import Vue from 'vue'
import store from './store'

export const clientDateFormat = 'DD/MM/YYYY'
export const serverDateFromat = 'YYYY-MM-DD'
export const timeCodeFromat = 'HH:mm:ss'

Vue.filter('dateFormatBase', (value) => {
  return dateFormatBase(value)
})

Vue.filter('decodeValue', (value, decoder) => {
  if (store.state.decoder.decoders[decoder] !== undefined) {
    return store.state.decoder.decoders[decoder][value]
  }
})

Vue.filter('secondsToTime', (value) => {
  return secondsToTime(value)
})

export function dateFormatBase (value) {
  if (value !== undefined && value !== null) {
    return moment(value.date).format(clientDateFormat)
  }
}

export function dateFormatServer (value) {
  if (value !== undefined && value !== null) {
    return value.format(serverDateFromat)
  }
}

export function dpParseDate (value) {
  if (value !== undefined && value !== null) {
    return moment(value.date)
  }
}

export function secondsToTime (value) {
  if (value !== undefined && value !== null) {
    return moment().startOf('day')
      .seconds(value)
      .format(timeCodeFromat)
  }
}

export function timeToSeconds (value) {
  if (value !== undefined && value !== null) {
    return moment.duration(value, timeCodeFromat)
      .asSeconds()
  }
}



// WEBPACK FOOTER //
// ./src/filters.js